export default "__VITE_ASSET__C3BZd7cV__"